var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"item B2 T3"},[_c('div',{staticClass:"name"},[_vm._v(_vm._s(_vm.item))]),_c('div',{staticClass:"time",class:{'reset-time':_vm.isSwitchable}},[_vm._v("到期时间")])])}
var staticRenderFns = []

export { render, staticRenderFns }